import BaseAPI from './base'
/**
 * API xử lý xếp hạng
 */
class EmisSupportAPI extends BaseAPI {}

export default new EmisSupportAPI('v1/emis-support', 'EmisSupport')
